module.exports = __webpack_public_path__ + "static/img/lumbarPainMan_1.598e262f.png";